const LightGroupsComponent = () => {
    return (
        <div>Light Groups</div>
    )
}

export default LightGroupsComponent